import { Breadcrumb } from "react-bootstrap";

const BreadCrumbs = ({
  mainPage,
  mainPageRoute,
  mainPageName,
  pageName,
  mainPageHref,
}) => {
  return (
    <div className="bread-crumb-container">
      <div className="container">
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            <i className="icon-home" />
          </Breadcrumb.Item>
          {mainPage && (
            <Breadcrumb.Item href={mainPageHref ? mainPageHref : ""} active>
              {mainPage}
            </Breadcrumb.Item>
          )}
          {mainPageName && (
            <Breadcrumb.Item href={mainPageRoute} active={!mainPageRoute}>
              {mainPageName}
            </Breadcrumb.Item>
          )}

          <Breadcrumb.Item active>{pageName}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
    </div>
  );
};

export default BreadCrumbs;
